'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Forbidden = require('../../Pages/Forbidden/Forbidden');

var _Forbidden2 = _interopRequireDefault(_Forbidden);

var _roles = require('../../../Container components/UserContainer/roles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  forbidden: {
    position: 'relative',
    paddingTop: '200px'
  }
};

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props, context) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));

    _this.isValid = (0, _roles.isAllowed)(props.allowedRoles, props.userRoles);
    return _this;
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      if (this.isValid) {
        return this.props.children;
      } else if (this.props.showError) {
        return _react2.default.createElement(_Forbidden2.default, { containerStyle: styles.forbidden });
      } else {
        return _react2.default.createElement('div', null);
      }
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.propTypes = {
  children: _react2.default.PropTypes.any.isRequired,
  userRoles: _react2.default.PropTypes.array.isRequired,
  allowedRoles: _react2.default.PropTypes.array.isRequired,
  showError: _react2.default.PropTypes.bool
};
exports.default = _class;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/Auth/UserPermission/UserPermission.js
 ** module id = 485
 ** module chunks = 0
 **/